import { Link } from 'react-router-dom';
import '../styles/NotFoundPage.scss';

export default function NotFoundPage() {
  return (
    <div className="not_found_container">
      <img src={"https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/auth_logo.svg"} alt="NMT Security" className="logo" />
      <h1 className="title">404 – Page Not Found</h1>
      <p className="message">
        Oops! We can’t find the page you’re looking for.
      </p>
      <Link to="/" className="homeLink">
        ← Back to Home
      </Link>
    </div>
  );
}
